import { useEffect, useState } from 'react'
import './style.scss'
import { parseHTMLString } from '../../utils/StringUtils'

export type ListItem = {
	title: string,
	content: string
}

// Strings will contain these 'type' tags to seperate different types of content with the normal corisponding html close tag for lists
// List items seperated by '<li>'
type HTMLStringItem = {
	type: '<p>' | '<ul>' | '<ol>',
	content: string[]
}

interface ExpandingListProps {
	items: ListItem[]
}

function ExpandingList({items}: ExpandingListProps) {
	const [expandedItems, setExpandedItems] = useState<boolean[]>([])

	useEffect(() => {
		setExpandedItems([])
	}, [items])

	const itemClickHandler = (itemIndex: number) => {
		const newExpandedItemsArr: boolean[] = [...expandedItems]
		if (newExpandedItemsArr[itemIndex]) {
			newExpandedItemsArr[itemIndex] = false
		} else {
			newExpandedItemsArr[itemIndex] = true
		}
		setExpandedItems(newExpandedItemsArr)
	}

	const splitHtmlStrings = (str: string): HTMLStringItem[] => {
		let htmlItems: HTMLStringItem[] = []
		const ulSplits: string[] = parseHTMLString(str).split('<ul>')
		ulSplits.forEach((olSplit: string) => {
			// if the string includes a close tag then the start of the string was '<ul>' in the original string
			const closeSplits: string[] = olSplit.split('</ul>')
			let paragraphsStr: string = ''
			if (closeSplits.length > 1) {
				htmlItems.push({
					type: '<ul>',
					content: closeSplits[0].split('<li>') 
				})
				paragraphsStr = closeSplits[1]
			} else {
				paragraphsStr = closeSplits[0]
			}
			if (paragraphsStr.length > 0) {
				htmlItems.push({
					type: '<p>',
					content: paragraphsStr.split('<p>')
				})
			}
		})
		return htmlItems
	}

	return (
		<div className='expanding-list-wrap'>
			{items.map((item: ListItem, index: number) => 
				<div 
					className='expanding-list-item'
					key={`listItem${index}`}
					onClick={() => {
						itemClickHandler(index)
					}}
				>
					<div className='expanding-list-item-title'>{index + 1}. {item.title}</div>
					{
						expandedItems[index] !== undefined && expandedItems[index] === true &&
							<div className='expanding-list-item-content'>
								{
									splitHtmlStrings(item.content).map((htmlString: HTMLStringItem, stringIndex: number) => {
										if (htmlString.type === '<ol>') {
											return <ol key={`htmlItem${stringIndex}`}>
												{htmlString.content.map((listItem: string, listIndex: number) => <li key={`listIndex${listIndex}`}>{listItem}</li>)}
											</ol>
										}
										if (htmlString.type === '<ul>') {
											return <ul key={`htmlItem${stringIndex}`}>
												{htmlString.content.map((listItem: string, listIndex: number) => <li key={`listIndex${listIndex}`}>{listItem}</li>)}
											</ul>
										}
										return htmlString.content.map((paragraphStr: string, paragraphIndex: number) => <p key={`paragraphStr${paragraphIndex}`}>{paragraphStr}</p>)
										// return <></>
									})
								}
							</div>
					}
					<img
						className={`expanding-list-item-button ${expandedItems[index] !== undefined && expandedItems[index] === true ? 'expanding-list-item-button-rotated' : ''}`}
						src='/imgs/icons/icon-faq-plus.svg'
						alt='open close indicator'
					/>
				</div>
			)}
		</div>
	)
}

export default ExpandingList
